import axios from "./axios-config";

export const getSiteRecord = async (keyword, page) => {

    let { data } = await axios.get(`/super-admin/dashboard`)
    return (data);

}